import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { GraduationCap, BriefcaseBusiness, ArrowRight } from "lucide-react";

import {
    BsGlobe2,
    BsCodeSlash,
    BsPhone,
    BsShieldCheck,
    BsLightningCharge,
    BsHeadset
} from "react-icons/bs";

import { FaGraduationCap, FaBriefcase } from "react-icons/fa";

import StudentImg from "../../images/collage1.jpg";
import BusinessImg from "../../images/bussness1.jpg";

import { motion, AnimatePresence } from "framer-motion";

import "./whytochoose.css";

const featureData = [
    {
        icon: <BsCodeSlash />,
        title: "Custom Development",
        desc: "Professional website development, mobile app development, and custom software solutions tailored to your business and academic needs."
    },
    {
        icon: <BsPhone />,
        title: "Responsive Design",
        desc: "Modern, responsive websites and mobile applications optimized for every device, ensuring speed, performance, and user experience."
    },
    {
        icon: <BsGlobe2 />,
        title: "High-Quality Coding",
        desc: "Complete business solutions and innovative college projects designed with industry standards and the latest technologies."
    },
    {
        icon: <BsLightningCharge />,
        title: "Fast Project Delivery",
        desc: "Efficient project development with timely delivery, high-quality coding, and reliable solutions for every client."
    },
    {
        icon: <BsShieldCheck />,
        title: "Secure & Scalable",
        desc: "Secure, scalable, and future-ready web and mobile solutions built using modern technologies and best practices."
    },
    {
        icon: <BsHeadset />,
        title: "24/7 Technical Support",
        desc: "Dedicated technical support, maintenance, and expert guidance to ensure your project runs smoothly at all times."
    },
    {
        icon: <BsShieldCheck />,
        title: "Modern Technologies",
        desc: "Built with the latest web, mobile, and software technologies for reliable performance."
    },
    {
        icon: <BsHeadset />,
        title: "Technical Support",
        desc: "Reliable technical support and maintenance to keep your projects running smoothly."
    }
];
export default function WhyChoose() {
    const [start, setStart] = useState(0);

    const visibleCards = 4;

    const nextSlide = () => {
        if (start + visibleCards < featureData.length) {
            setStart(start + visibleCards);
        }
    };
    const prevSlide = () => {
        if (start - visibleCards >= 0) {
            setStart(start - visibleCards);
        } else {
            setStart(0);
        }
    };

    return (
        <section className="feature-wrapper">

            <Container fluid>
                        <h2>
                            Why Clients Trust Our  Solutions              <br />
                        </h2>
                <Row className="align-items-center feature-main">

                    {/* Left */}

                    <Col lg={3} md={12} className="left-side">

                        

                        <div className="arrow-group">

                            <button onClick={prevSlide}>
                                <FaChevronLeft />
                            </button>

                            <button onClick={nextSlide}>
                                <FaChevronRight />
                            </button>

                        </div>

                    </Col>

                    {/* Right */}

                    <Col lg={9} className="cards-area">

                        <AnimatePresence mode="wait">

                            <motion.div
                                key={start}
                                className="cards-row"
                                initial={{ x: 80, opacity: 0 }}
                                animate={{ x: 0, opacity: 1 }}
                                exit={{ x: -80, opacity: 0 }}
                                transition={{ duration: .4 }}
                            >

                                {featureData
                                    .slice(start, start + visibleCards)
                                    .map((item, index) => (

                                        <div className="feature-card" key={index}>

                                            <div className="icon-circle">
                                                {item.icon}
                                            </div>

                                            <h5>{item.title}</h5>

                                            <p>{item.desc}</p>

                                        </div>

                                    ))}

                            </motion.div>

                        </AnimatePresence>

                    </Col>

                </Row>

            </Container>


            <section className="profile-business-section">
      <div className="container-fluid px-4 px-md-5">
        <div className="row g-4">
            <h2 style={{padding:'30px 0px 0px 0px '}}>Build Your Future. Grow Your Business.</h2>
          {/* Student Card */}
          <div className="col-lg-6">
            <div className="profile-business-card profile-business-student">

              <div className="profile-business-icon">
                <GraduationCap size={32} strokeWidth={2} />
              </div>

              <div className="profile-business-line"></div>

              <div className="profile-business-label">
                FOR STUDENTS
              </div>

              <h3 className="profile-business-title">
                Build a profile that sells.
              </h3>

              <p className="profile-business-description">
                Craft a professional resume, curate your best work in a
                portfolio and document your final-year project — all with
                structured templates.
              </p>

              <ul className="profile-business-list">
                <li>Resume template with live preview</li>
                <li>Portfolio showcase with project cards</li>
                <li>Final year project doc, listable for sale</li>
              </ul>

              <button className="profile-business-btn">
                Start your profile
                <ArrowRight size={22} />
              </button>

            </div>
          </div>

          {/* Business Card */}
          <div className="col-lg-6">
            <div className="profile-business-card profile-business-company">

              <div className="profile-business-icon">
                <BriefcaseBusiness size={32} strokeWidth={2} />
              </div>

              <div className="profile-business-line"></div>

              <div className="profile-business-label">
                FOR BUSINESSES
              </div>

              <h3 className="profile-business-title">
                Skip the design cycle.
              </h3>

              <p className="profile-business-description">
                Register your business, browse a curated gallery of
                production-ready website templates and pick one that fits
                your brand.
              </p>

              <ul className="profile-business-list">
                <li>Curated business website templates</li>
                <li>Live previews & feature breakdowns</li>
                <li>One dashboard for your business</li>
              </ul>

              <button className="profile-business-btn">
                Explore templates
                <ArrowRight size={22} />
              </button>

            </div>
          </div>

        </div>
      </div>
    </section>

        </section>
    );
}